import { highlightSimple, unhighlightSimple } from "../../utils";

export function initSearchTable() {
	const blockElement = document.querySelector(".wp-block-brblocks-magictools");
	if (!blockElement) return;

	const tableAnchorId = blockElement.getAttribute("data-table-anchor");
	let tableAnchor = null;

	if (tableAnchorId) {
		if (tableAnchorId.startsWith(".") || tableAnchorId.startsWith("#")) {
			tableAnchor =
				document.querySelector(`${tableAnchorId} table`) ||
				document.querySelector(tableAnchorId);
		} else {
			tableAnchor =
				document.querySelector(`figure#${tableAnchorId} table`) ||
				document.querySelector(`#${tableAnchorId} table`) ||
				document.querySelector(`#${tableAnchorId}`);
		}
	}

	if (!tableAnchor) return;

	const searchInput = document.getElementById("searchInput");
	const clearSearchButton = document.getElementById("clearSearch");

	const noDataMessage = document.createElement("div");
	noDataMessage.textContent = "Unfortunately, no match was found.";
	Object.assign(noDataMessage.style, {
		display: "none",
		color: "red",
		marginTop: "6px",
	});
	tableAnchor.parentElement.appendChild(noDataMessage);

	function isGroupHeader(row) {
		const a = row.querySelector("a");
		if (!a) return false;
		const style = (a.getAttribute("style") || "").toLowerCase();
		return !style.includes("padding-left");
	}

	if (!searchInput) return;

	searchInput.addEventListener("input", function () {
		const searchTerm = this.value.trim().toLowerCase();
		const rows = Array.from(tableAnchor.querySelectorAll("tbody tr"));
		let found = false;

		rows.forEach((r) =>
			r.querySelectorAll("td,th").forEach((c) => unhighlightSimple(c))
		);

		const hasGroups = rows.some((r) => isGroupHeader(r));

		if (hasGroups) {
			const groups = [];
			let current = [];
			rows.forEach((r) => {
				if (isGroupHeader(r)) {
					if (current.length) groups.push(current);
					current = [r];
				} else {
					current.push(r);
				}
			});
			if (current.length) groups.push(current);

			groups.forEach((grp) => {
				let match = !searchTerm;
				if (searchTerm) {
					outer: for (const r of grp) {
						for (const c of r.querySelectorAll("td,th")) {
							if (c.textContent.toLowerCase().includes(searchTerm)) {
								match = true;
								break outer;
							}
						}
					}
				}
				grp.forEach((r) => (r.style.display = match ? "" : "none"));
				if (match && searchTerm) {
					grp.forEach((r) =>
						r
							.querySelectorAll("td,th")
							.forEach((c) => highlightSimple(c, searchTerm))
					);
				}
				if (match) found = true;
			});
		} else {
			rows.forEach((r) => {
				let show = !searchTerm;
				if (searchTerm) {
					for (const c of r.querySelectorAll("td,th")) {
						if (c.textContent.toLowerCase().includes(searchTerm)) {
							show = true;
							break;
						}
					}
				}
				r.style.display = show ? "" : "none";
				if (show && searchTerm) {
					r.querySelectorAll("td,th").forEach((c) =>
						highlightSimple(c, searchTerm)
					);
				}
				if (show) found = true;
			});
		}

		noDataMessage.style.display = found ? "none" : "block";
		if (clearSearchButton)
			clearSearchButton.style.display = searchTerm ? "inline-block" : "none";
	});

	if (clearSearchButton) {
		clearSearchButton.addEventListener("click", function () {
			searchInput.value = "";
			const rows = tableAnchor.querySelectorAll("tbody tr");
			rows.forEach((r) => {
				r.style.display = "";
				r.querySelectorAll("td,th").forEach((c) => unhighlightSimple(c));
			});
			noDataMessage.style.display = "none";
			clearSearchButton.style.display = "none";
			searchInput.focus();
		});
	}
}
